<div class="p-6 max-w-3xl mx-auto">

  <div class="mb-5">
    <div class="flex items-center gap-2 mb-1">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Probar Acciones CRM</h1>
      <span class="px-2 py-0.5 text-xs bg-indigo-100 text-indigo-700 rounded-full font-medium">RF-07</span>
    </div>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Prueba acciones sobre registros del CRM sin ejecutar un workflow completo.
    </p>
  </div>

  @if (isDangerousAction) {
    <div class="mb-4 p-3 bg-red-50 border border-red-300 text-red-700 rounded-lg text-sm flex items-start gap-2">
      <svg class="w-5 h-5 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"/>
      </svg>
      <div>
        <p class="font-semibold">Acción peligrosa</p>
        <p class="text-xs mt-0.5">"Eliminar registro" borra el registro de forma permanente. Solo pueden ejecutarla los administradores y el workflow debe tener habilitadas las acciones peligrosas.</p>
      </div>
    </div>
  }

  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span><button (click)="error = ''">&times;</button>
    </div>
  }

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">

    <!-- Formulario -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Configuración</h2>
      <div class="space-y-3">

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de acción CRM *</label>
          <select [(ngModel)]="actionType" (ngModelChange)="result = null; error = ''"
                  class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
            @for (opt of actionTypeOptions; track opt.value) {
              <option [value]="opt.value">{{ opt.label }}</option>
            }
          </select>
        </div>

        <div class="grid grid-cols-2 gap-2">
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de objeto</label>
            <select [(ngModel)]="objectType" (ngModelChange)="onObjectTypeChange()"
                    class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
              @for (ot of objectTypeOptions; track ot.value) { <option [value]="ot.value">{{ ot.label }}</option> }
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Registro (opcional)</label>
            @if (recordSelect.isSearchable()) {
              <app-entity-select
                [value]="objectId"
                (valueChange)="objectId = $event"
                (selected)="onRecordSelected($event)"
                [displayText]="recordDisplayText"
                [searchFn]="recordSelect.search" [labelFn]="recordSelect.label" [sublabelFn]="recordSelect.sublabel"
                placeholder="Buscar por nombre…"></app-entity-select>
            } @else {
              <input type="number" [(ngModel)]="objectId" placeholder="Ej: 42"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
            }
          </div>
        </div>

        <!-- SET_PROPERTY_VALUE -->
        @if (isSetProperty) {
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Propiedad *</label>
              <input [(ngModel)]="spvProperty" placeholder="Ej: phone"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Operación</label>
              <select [(ngModel)]="spvOperation" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
                @for (o of spvOperationOptions; track o.value) { <option [value]="o.value">{{ o.label }}</option> }
              </select>
            </div>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Valor</label>
            <input [(ngModel)]="spvValue" placeholder="Admite tokens, ej: {{ '{{' }}contact.email{{ '}}' }}"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="spvContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- COPY_PROPERTY_VALUE -->
        @if (isCopyProperty) {
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Origen</label>
              <select [(ngModel)]="cpvSourceType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
                @for (s of sourceTypeOptions; track s.value) { <option [value]="s.value">{{ s.label }}</option> }
              </select>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Propiedad origen *</label>
              <input [(ngModel)]="cpvSourceProperty" placeholder="Ej: company.industry"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
            </div>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Propiedad destino *</label>
            <input [(ngModel)]="cpvTargetProperty" placeholder="Ej: description"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="cpvContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- CREATE_RECORD -->
        @if (isCreateRecord) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de registro a crear *</label>
            <select [(ngModel)]="crObjectType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
              @for (ot of crmObjectTypeOptions; track ot.value) { <option [value]="ot.value">{{ ot.label }}</option> }
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Campos del registro *</label>
            <div class="space-y-1.5">
              @for (f of crFields; track $index) {
                <div class="flex gap-1.5 items-center">
                  <input [(ngModel)]="f.property" placeholder="Propiedad"
                         class="flex-1 px-2.5 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"/>
                  <input [(ngModel)]="f.value" placeholder="Valor (admite tokens)"
                         class="flex-1 px-2.5 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"/>
                  <button type="button" (click)="removeCrField($index)" class="text-red-400 hover:text-red-600 px-1">&times;</button>
                </div>
              }
            </div>
            <button type="button" (click)="addCrField()" class="mt-1.5 text-xs text-indigo-600 hover:underline">+ Agregar campo</button>
          </div>
          <div class="flex flex-wrap gap-4">
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="crAssociate" class="w-3.5 h-3.5 rounded text-indigo-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Asociar al registro actual</span>
            </label>
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="crContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
            </label>
          </div>
        }

        <!-- ASSOCIATE_RECORDS -->
        @if (isAssociate) {
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo destino *</label>
              <select [(ngModel)]="arTargetObjectType" (ngModelChange)="arTargetObjectId = null; arTargetName = ''"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
                @for (ot of crmObjectTypeOptions; track ot.value) { <option [value]="ot.value">{{ ot.label }}</option> }
              </select>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Registro destino *</label>
              @if (arTargetSelect.isSearchable()) {
                <app-entity-select
                  [value]="arTargetObjectId"
                  [displayText]="arTargetName"
                  (valueChange)="arTargetObjectId = $event"
                  (selected)="onArTargetSelected($event)"
                  [searchFn]="arTargetSelect.search" [labelFn]="arTargetSelect.label" [sublabelFn]="arTargetSelect.sublabel"
                  placeholder="Buscar por nombre…"></app-entity-select>
              } @else {
                <input type="number" [(ngModel)]="arTargetObjectId" placeholder="ID"
                       class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
              }
            </div>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de asociación *</label>
            <input [(ngModel)]="arAssociationType" placeholder="Ej: PRIMARY_COMPANY, DEAL_CONTACT"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="arContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- ASSIGN_OWNER_ROUND_ROBIN -->
        @if (isRoundRobin) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Usuarios del reparto rotativo *</label>
            @if (aorrUserIdList.length) {
              <div class="flex flex-wrap gap-1.5 mb-2">
                @for (uid of aorrUserIdList; track uid) {
                  <span class="inline-flex items-center gap-1 px-2 py-0.5 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 text-xs rounded-full">
                    {{ userNameById(uid) }}
                    <button type="button" (click)="removeRoundRobinUser(uid)" class="hover:text-indigo-900 ml-0.5">&times;</button>
                  </span>
                }
              </div>
            }
            <app-entity-select
              [value]="null"
              (valueChange)="addRoundRobinUser($event)"
              [searchFn]="userSearch" [labelFn]="userLabel" [sublabelFn]="userSublabel"
              [allowClear]="false"
              placeholder="Buscar usuario para agregar…"></app-entity-select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Clave de estado (persistir turno)</label>
            <input [(ngModel)]="aorrStateKey" placeholder="Ej: sales_leads_rr"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="aorrContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- ASSIGN_OWNER_ROUTING -->
        @if (isRouting) {
          <div>
            <p class="text-xs font-medium text-gray-700 dark:text-gray-300 mb-1.5">Reglas de asignación</p>
            @for (rule of aorRules; track $index; let i = $index) {
              <div class="mb-2 p-2 bg-gray-50 dark:bg-gray-700/40 rounded-lg border border-gray-100 dark:border-gray-600">
                <div class="grid grid-cols-2 gap-1.5 mb-1.5">
                  <app-wf-property-select
                    [value]="rule.property" [options]="routingPropertyOptions"
                    placeholder="Propiedad"
                    (valueChange)="rule.property = $event"></app-wf-property-select>
                  <select [(ngModel)]="rule.operator" class="px-1.5 py-1 text-xs border border-gray-200 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-1 focus:ring-indigo-500">
                    @for (op of operatorOptionsFor(rule.property, rule.operator); track op.value) { <option [value]="op.value">{{ op.label }}</option> }
                  </select>
                  <!--
                    Mismo editor que el constructor: la regla que se prueba aquí se guarda igual que
                    la del nodo, así que el valor se elige igual (lista, buscador, número, fecha o
                    variable) en vez de teclearse a ciegas.
                  -->
                  <app-wf-condition-value
                    [operator]="rule.operator" [value]="rule.value" [property]="rule.property"
                    [options]="routingPropertyOptions" placeholder="Valor"
                    (patch)="rule.value = $event['value']" />
                  <app-entity-select
                    [value]="rule.ownerUserId"
                    [displayText]="userNameById(rule.ownerUserId)"
                    (valueChange)="rule.ownerUserId = $event"
                    [searchFn]="userSearch" [labelFn]="userLabel" [sublabelFn]="userSublabel"
                    placeholder="Responsable…"></app-entity-select>
                </div>
                @if (aorRules.length > 1) {
                  <button (click)="removeAorRule(i)" class="text-xs text-red-400 hover:text-red-600">− Eliminar regla</button>
                }
              </div>
            }
            <button (click)="addAorRule()" class="text-xs text-indigo-600 hover:underline">+ Agregar regla</button>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Responsable por defecto</label>
            <app-entity-select
              [value]="aorFallbackOwnerId"
              [displayText]="userNameById(aorFallbackOwnerId)"
              (valueChange)="aorFallbackOwnerId = $event"
              [searchFn]="userSearch" [labelFn]="userLabel" [sublabelFn]="userSublabel"
              [allowClear]="true"
              placeholder="Buscar usuario…"></app-entity-select>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="aorContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- ADD/REMOVE_STATIC_LIST -->
        @if (isStaticList) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de lista *</label>
            <select [(ngModel)]="listType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
              @for (lt of listTypeOptions; track lt.value) { <option [value]="lt.value">{{ lt.label }}</option> }
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Lista estática *</label>
            <app-entity-select
              [value]="listId"
              [displayText]="listName"
              (valueChange)="listId = $event"
              (selected)="onListSelected($event)"
              [searchFn]="listSearch" [labelFn]="segmentLabel"
              [allowClear]="true"
              placeholder="Buscar lista estática por nombre…"></app-entity-select>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="listContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- ENROLL_IN_WORKFLOW -->
        @if (isEnroll) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Workflow destino *</label>
            <app-entity-select
              [value]="enrollTargetWorkflowId"
              [displayText]="enrollWorkflowName"
              (valueChange)="enrollTargetWorkflowId = $event"
              (selected)="onEnrollWorkflowSelected($event)"
              [searchFn]="workflowSearch" [labelFn]="workflowLabel"
              [allowClear]="true"
              placeholder="Buscar workflow por nombre…"></app-entity-select>
            @if (enrollTargetVersionId) {
              <p class="text-[11px] text-gray-400 mt-1">Se usará la versión publicada del workflow seleccionado.</p>
            }
          </div>
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de objeto</label>
              <select [(ngModel)]="enrollObjectType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
                @for (ot of crmObjectTypeOptions; track ot.value) { <option [value]="ot.value">{{ ot.label }}</option> }
              </select>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Fuente del ID</label>
              <select [(ngModel)]="enrollObjectIdSource" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
                @for (s of enrollObjectIdSourceOptions; track s.value) { <option [value]="s.value">{{ s.label }}</option> }
              </select>
            </div>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="enrollContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- UNENROLL_FROM_WORKFLOW -->
        @if (isUnenroll) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Workflow destino *</label>
            <app-entity-select
              [value]="unenrollTargetWorkflowId"
              [displayText]="unenrollWorkflowName"
              (valueChange)="unenrollTargetWorkflowId = $event"
              (selected)="onUnenrollWorkflowSelected($event)"
              [searchFn]="workflowSearch" [labelFn]="workflowLabel"
              [allowClear]="true"
              placeholder="Buscar workflow por nombre…"></app-entity-select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de objeto</label>
            <select [(ngModel)]="unenrollObjectType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
              @for (ot of crmObjectTypeOptions; track ot.value) { <option [value]="ot.value">{{ ot.label }}</option> }
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Motivo (opcional)</label>
            <input [(ngModel)]="unenrollReason" placeholder="Ej: Movido a otro flujo"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="unenrollContinueOnError" class="w-3.5 h-3.5 rounded text-indigo-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- DELETE_RECORD -->
        @if (isDelete) {
          <div class="p-3 bg-red-50 dark:bg-red-900/20 border border-red-300 dark:border-red-800 rounded-lg text-xs text-red-700 dark:text-red-400">
            Se eliminará permanentemente el registro seleccionado. Requiere permisos de Admin y que el workflow permita acciones peligrosas.
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="deleteContinueOnError" class="w-3.5 h-3.5 rounded text-red-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- Contexto de prueba (opcional) -->
        <div class="border-t border-gray-100 dark:border-gray-700 pt-3">
          <button type="button" (click)="showContext = !showContext"
                  class="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
            <svg class="w-3.5 h-3.5 transition-transform" [class.rotate-90]="showContext" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
            Datos de contexto para tokens (opcional)
          </button>
          @if (showContext) {
            <textarea [(ngModel)]="contextJson" rows="4" placeholder='{ "contact": { "firstname": "Juan" } }'
                      class="mt-2 w-full px-3 py-2 text-xs font-mono border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"></textarea>
          }
        </div>

        <button (click)="test()" [disabled]="loading"
                class="w-full py-2 text-sm rounded-lg disabled:opacity-50 transition-colors inline-flex items-center justify-center gap-2"
                [ngClass]="isDangerousAction
                  ? 'bg-red-600 text-white hover:bg-red-700'
                  : 'bg-indigo-600 text-white hover:bg-indigo-700'">
          @if (loading) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
            Ejecutando...
          } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3l14 9-14 9V3z"/>
            </svg>
            {{ isDangerousAction ? 'Ejecutar (peligrosa)' : 'Ejecutar acción CRM' }}
          }
        </button>
      </div>
    </div>

    <!-- Resultado -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Resultado</h2>

      @if (!result && !loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-300 dark:text-gray-600">
          <svg class="w-10 h-10 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <p class="text-sm">Ejecuta una acción CRM para ver el resultado</p>
        </div>
      }

      @if (loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-400">
          <svg class="animate-spin w-8 h-8 mb-3" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
          </svg>
          <p class="text-sm">Ejecutando acción CRM...</p>
        </div>
      }

      @if (result && !loading) {
        <!-- Status -->
        <div class="flex items-center gap-3 mb-4 p-3 rounded-lg"
             [ngClass]="result.status === 'SUCCESS' ? 'bg-green-50 dark:bg-green-900/20' : result.status === 'SKIPPED' ? 'bg-gray-50 dark:bg-gray-700/40' : 'bg-red-50 dark:bg-red-900/20'">
          <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold" [ngClass]="getStatusClass(result.status)">
            {{ statusLabel(result.status) }}
          </span>
          <p class="text-sm text-gray-700 dark:text-gray-300">{{ result.message }}</p>
        </div>

        <!-- Key details -->
        <dl class="space-y-2 text-sm mb-4">
          @if (result.actionType) {
            <div class="flex justify-between py-1 border-b border-gray-100 dark:border-gray-700">
              <dt class="text-xs text-gray-500">Tipo de acción</dt>
              <dd class="text-xs font-medium text-gray-900 dark:text-white">{{ actionTypeLabel(result.actionType) }}</dd>
            </div>
          }
          @if (result.targetObjectType) {
            <div class="flex justify-between py-1 border-b border-gray-100 dark:border-gray-700">
              <dt class="text-xs text-gray-500">Objeto afectado</dt>
              <dd class="text-xs font-medium text-gray-900 dark:text-white" [title]="result.targetObjectType || ''">
                {{ recordText(result.targetObjectType, result.targetObjectId) }}
              </dd>
            </div>
          }
        </dl>

        <!-- Output -->
        @if (result.output && (result.output | json) !== '{}') {
          <div class="mb-3">
            <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Resultado (JSON)</p>
            <pre class="text-xs font-mono bg-gray-50 dark:bg-gray-700/40 p-3 rounded-lg overflow-x-auto text-gray-800 dark:text-gray-200 max-h-40 whitespace-pre-wrap">{{ resultJson }}</pre>
          </div>
        }

        <!-- Error details -->
        @if (result.error && (result.error | json) !== '{}') {
          <div>
            <p class="text-xs font-semibold text-red-500 uppercase tracking-wide mb-1">Error</p>
            <pre class="text-xs font-mono bg-red-50 dark:bg-red-900/20 p-3 rounded-lg overflow-x-auto text-red-800 dark:text-red-300 max-h-32 whitespace-pre-wrap">{{ errorJson }}</pre>
          </div>
        }
      }
    </div>
  </div>

  <!-- Info note -->
  <div class="mt-4 p-3 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg text-xs text-indigo-700 dark:text-indigo-300">
    <p class="font-semibold mb-1">Acciones disponibles en RF-07 (Registros CRM):</p>
    <div class="flex flex-wrap gap-1.5 mt-1">
      @for (opt of actionTypeOptions; track opt.value) {
        <span class="px-1.5 py-0.5 bg-indigo-100 dark:bg-indigo-900/30 rounded text-[10px]">{{ opt.label }}</span>
      }
    </div>
    <p class="mt-2 text-indigo-500">Crear tarea y Crear nota se prueban en Acciones de Actividad; los webhooks, en Probar Webhooks; y las acciones sobre tickets, en Acciones de Pipeline y en el propio constructor.</p>
  </div>
</div>
